module.exports = __webpack_public_path__ + "media/images/icons/view-188c21e17b3d352ba76fea8efe221539.svg";